import { render } from "./ProductsPage.vue?vue&type=template&id=939a9e2c&scoped=true"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"

import "./ProductsPage.vue?vue&type=style&index=0&id=939a9e2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939a9e2c"]])

export default __exports__